module.exports = __webpack_public_path__ + "img/icon1.54ca6db0.gif";